import { createResource } from 'react-resource-router';

import { type ResourceDependencies } from '../../../common/types';
import { getStatus } from '../../endpoints/status';

import { transformStatusResponse } from './utils';

export const createStatusResource = (
	checkConsolidationOnRouteDependency?: (dependencies: ResourceDependencies) => Promise<boolean>,
	depends?: string[],
) =>
	createResource({
		type: 'statusResource',
		getKey: () => 'statusResource',
		getData: async ({ dependencies }) => {
			const isConsolidated = checkConsolidationOnRouteDependency
				? await checkConsolidationOnRouteDependency(dependencies as ResourceDependencies)
				: true;

			if (!isConsolidated) {
				return null;
			}

			return getStatus().then(transformStatusResponse);
		},
		isBrowserOnly: true,
		depends,
	});
